module.exports = __webpack_public_path__ + "img/FPL_Home_logo.svg";